<template>
  <div>
      <section class="section-shaped my-0">
          <div class="shape shape-skew">
              <img src="/img/bkgrnd.jpg" class="img-fluid">
          </div>

            <div class="d-none d-lg-block container shape-container">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                          <img src="/img/devconf_logo_white_poly.png" width="100%">
                          <center class="heading">News</center>
                        </div>
                    </div>
                </div>
            </div>

      </section>

      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5">
                              <div class="row row-grid">
                                  <b-card
                                    v-bind:title="article.title"
                                    v-bind:img-src="'/img/article/' + article.image"
                                    img-alt="Image"
                                    img-top
                                    tag="article"
                                    v-for="article in articles"
                                    style="margin:10px;"
                                    class="mb-2 col-lg-11">
                                    <b-card-text>
                                      {{article.excerpt}}
                                    </b-card-text>
                                  <base-button type="info" @click="openArticle(article.index)" outline class="pull-right">Lees meer</base-button>
                                </b-card>
                              </div>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>
  </div>
</template>

<script>
import Articles from "@/data/ArticleMetaData.js";
export default {
  data(){
    return {
      articles: [],
    }
  },
  mounted(){
    Articles.list().then(response => {
      this.articles = response.data.reverse();
    });
  },
  methods: {
    openArticle(index){
      location.href = "/article/" + index;
    }
  }
}
</script>
